export default {
  searchTerm: 'a',
  meals: [],
  loading: true,
  meal: {},
};
